import http from "@app/lib/http";
import { observable, action } from "mobx";

/**
 * Article Galaxy service for frontend API calls
 */
export class ArticleGalaxyService {
    @observable loading = false;
    @observable error = null;

    /**
     * Place order for article in Article Galaxy
     */
    @action
    async placeOrder(projectId, articleId) {
        this.loading = true;
        this.error = null;

        try {
            const response = await http.post(
                `/project/${projectId}/article/${articleId}/article-galaxy/place-order`,
            );

            this.loading = false;
            return response.data;
        } catch (error) {
            this.loading = false;
            this.error = error;
            throw error;
        }
    }

    /**
     * Download article from Article Galaxy (returns { ready, pdfUrl })
     */
    @action
    async download(projectId, articleId) {
        this.loading = true;
        this.error = null;

        try {
            const response = await http.post(
                `/project/${projectId}/article/${articleId}/article-galaxy/download`,
            );

            this.loading = false;
            return response.data;
        } catch (error) {
            this.loading = false;
            this.error = error;
            throw error;
        }
    }

    /**
     * Reset loading and error states
     */
    @action
    reset() {
        this.loading = false;
        this.error = null;
    }
}

// Create singleton instance
const articleGalaxyService = new ArticleGalaxyService();
export default articleGalaxyService;
